$.fn.countUp = function() {
    $(this).text(0);
    const target_number = parseInt($(this).data('target'));

    let speed_coefficient = parseInt($(this).data('speed'));
    if(!speed_coefficient){
        speed_coefficient = 3500;
    }

    let increment = 1;
    if(target_number > 1000){
        increment = Math.ceil(target_number / 1000);
    }
    const speed = speed_coefficient / target_number;

    const updateCount = () => {
        const current_number = parseInt($(this).text());

        if (current_number < target_number) {
            $(this).text(current_number + increment);
            setTimeout(updateCount, speed);
        } else {
            $(this).text(target_number);
        }
    }

    updateCount();
    $(this).addClass('js-activated');
}

$(window). on('resize scroll', function () {
    checkIfCountUpInViewport();
});

$(document).ready(function(){
    checkIfCountUpInViewport();
})

function checkIfCountUpInViewport(){
    let theElementsToWatch = $('.js-counting');
    theElementsToWatch.each(function(index){
        if (isInViewport($(this))) {
            if(!$(this).hasClass('js-activated')) {
                $(this).countUp();
            }
        }
    })
}

function isInViewport(el) {
    let elementTop = el.offset().top;
    let elementBottom = elementTop +el.outerHeight();
    let viewportTop = $(window).scrollTop();
    let viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
}
